export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/toggle-close.1cdcfe67.svg","height":16,"width":16};